module.exports = __webpack_public_path__ + "static/media/bg_mail.e96b0606.svg";